


// import Swiper styles
import 'swiper/css/bundle';
import 'animate.css';

// Import our custom CSS
import './scss/styles.scss'
import './styl/index.styl'

// import Swiper JS
import Swiper from 'swiper/bundle';

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

import Action from './control/actionControl';

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.banner.swiper', {
    // Optional parameters
    loop: true,
    autoplay: {
      delay: 5000,
    },

    // pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  const appSwiper = new Swiper('.app-slider .app-swiper', {
    // Optional parameters
    loop: true,
    autoplay: {
      delay: 5000,
    },
    slidesPerView: 3,
    spaceBetween: 10,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3
      }
    },
    // pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
  
  new Action()
})

